import React, { useEffect, useState } from 'react';
// import PageTitle from '../layout/PageTitle';
import Footer from '../layout/Footer';
import { Container, Row, Col, Card, Dropdown, Table, Button } from 'react-bootstrap';
import Chart from "react-apexcharts";

// icons
import Icon from '@mdi/react';
import { mdiReceiptTextOutline, mdiDotsHorizontal, mdiRefresh, mdiFormatListCheckbox, mdiTrashCanOutline, mdiCircle, mdiCircleBoxOutline, mdiReload, mdiDotsVertical, mdiFinance, mdiCardAccountDetailsOutline } from '@mdi/js';

// table-data json files
import purchaseProduct from "./purchase-product-data.json";
import salesProduct from "./sales-product-data.json";
import alertQuantity from "./alert-quantity-data.json";

import charts from "./dashboardChart";
import { getFromAPI } from '../../Utils/utils';
import { fetchTaxData, fetchProductCategoryData, fetchUnitData, fetchBrandData, fetchVendorData } from '../../Utils/function_list';
import TableElement from '../../Utils/elements/TableElement';


export default function Dashboard() {
    // table-data
    const [purchaseProductData] = useState(purchaseProduct);
    const [salesProductData] = useState(salesProduct);
    const [alertQuantityData] = useState(alertQuantity);
    const [productData, setProductData] = useState([]);
    const [productCategory, setProductCategory] = useState([]);

    useEffect(() => {
        fetchProductCategoryData(setProductCategory);
    }, []);

    const fetchProductData = async () => {
        try {
            const response = await getFromAPI('FtsWarehouse/');

            // Filter the response to only include products with alert quantities <= 10
            const filteredData = response.filter(
                item => item.alert_consumable_quantity <= 10 || item.alert_retail_quantity <= 10
            );
            setProductData(filteredData);
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    };

    useEffect(() => {
        fetchProductData();
    }, []);

    const getProductCategoryNameById = (prodCatID) => {
        let prodCat = productCategory.find(pc => pc.id === prodCatID);
        return prodCat ? prodCat.name : 'Unknown category';
    };

    const iconMap = {
        mdiCircle,
        mdiCircleBoxOutline,
        // Add more icon mappings as needed
      };

    // Total Sales Product table data
    const topSalesProd = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Product Name', 'Qty', 'HSN', 'Amount'],
        tbody: salesProductData.map((item) => ({
            productname: { type: 'text', text: item.productName },
            qty: { type: 'text', text: item.productQty },
            hsn: { type: 'text', text: item.productHsn },
            amount: { type: 'text', text: item.productAmount }
        }))
    };

    // Total Purchase Product table data
    const topPurchaseProd = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Product Name', 'Qty', 'HSN', 'Amount'],
        tbody: purchaseProductData.purchaseProductItem.map((item) => ({
            productname: { type: 'text', text: item.productName },
            qty: { type: 'text', text: item.productQty },
            hsn: { type: 'text', text: item.productHsn },
            amount: { type: 'text', text: item.productAmount }
        }))
    };

    const providerStatus = {
        tableClass: 'table-nowrap mb-0',
        thead: ['Provider', 'Attendance', 'Status'],
        tbody: purchaseProductData.providerStatusList.map((item) => ({
            provider: { type: 'imageWithText', image: item.userImg, text: item.userName },
            attendance: { type: 'icon', icon: iconMap[item.iconName], iconClass: item.iconColor },
            status: { type: 'badge', text: item.badgeText, badgeColor: item.badgeColor }
        }))
    }

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    {/* <PageTitle breadcrumbLast="Dashboard" /> */}
                    <Container>
                        <Row>
                            <Col sm={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            <div>
                                                <h2 className='mb-1'>24</h2>
                                                <p className='mb-0 fs-16 text-muted'>Invoice of the day</p>
                                            </div>
                                            <div className='avatar avatar-xl bg-soft-primary text-primary'>
                                                <Icon path={mdiReceiptTextOutline} className='avatar-icon' />
                                            </div>
                                        </div>
                                        <Chart options={charts.invoiceChart.options} type="bar" series={charts.invoiceChart.series} width="100%" height="120px" />
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            <div>
                                                <h2 className='mb-1'>$260.00</h2>
                                                <p className='mb-0 fs-16 text-muted'>Sales of the day</p>
                                            </div>
                                            <div className='avatar avatar-xl bg-soft-success text-success'>
                                                <Icon path={mdiFinance} className='avatar-icon' />
                                            </div>
                                        </div>

                                        <Chart options={charts.salesChart.options} type="area" series={charts.salesChart.series} width="100%" height="120px" />
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            <div>
                                                <h2 className='mb-1'>36</h2>
                                                <p className='mb-0 fs-16 text-muted'>Visits of the week</p>
                                            </div>
                                            <div className='avatar avatar-xl bg-soft-info text-info'>
                                                <Icon path={mdiCardAccountDetailsOutline} className='avatar-icon' />
                                            </div>
                                        </div>

                                        <Chart options={charts.visitsChart.options} type="bar" series={charts.visitsChart.series} width="100%" height="120px" />
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            <div>
                                                <h2 className='mb-1'>$106.00</h2>
                                                <p className='mb-0 fs-16 text-muted'>Expenses of the day</p>
                                            </div>
                                            <div className='avatar avatar-xl bg-soft-danger text-danger'>
                                                <Icon path={mdiFinance} className='avatar-icon' />
                                            </div>
                                        </div>

                                        <Chart options={charts.expensesChart.options} type="area" series={charts.expensesChart.series} width="100%" height="120px" />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col xl={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Sales Report</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>

                                        <Chart options={charts.salesReportChart.options} type="line" series={charts.salesReportChart.series} width="100%" height="295px" />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xl={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Provider Status</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href=""><Icon path={mdiRefresh} className='icon-size-14 me-1' /> Refresh</Dropdown.Item>
                                                    <Dropdown.Item href=""><Icon path={mdiFormatListCheckbox} className='icon-size-14 me-1' /> View More</Dropdown.Item>
                                                    <Dropdown.Item href=""><Icon path={mdiTrashCanOutline} className='icon-size-14 me-1' /> Delete</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>

                                        <TableElement tableClass={providerStatus.tableClass} thead={providerStatus.thead} tbodydata={providerStatus.tbody} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Top Product Sold</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Polo T-shirt</h5>
                                                <p className='mb-0 fs-14'>Polo Brand T-shirt</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$960.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Headphones</h5>
                                                <p className='mb-0 fs-14'>Boat Brand Headphones</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$810.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Nike Shoes</h5>
                                                <p className='mb-0 fs-14'>Nike Brand Sports Shoes</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$640.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Milton Bottle</h5>
                                                <p className='mb-0 fs-14'>Milton Brand Water Bottle</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$640.00</h4>
                                        </div>
                                        <hr />

                                        <div className='text-center'>
                                            <Button variant="primary">Loading <Icon spin path={mdiReload} className="btn-icon ms-1" /></Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} xl={3}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Top Product Sold</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Polo T-shirt</h5>
                                                <p className='mb-0 fs-14'>Polo Brand T-shirt</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$960.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Headphones</h5>
                                                <p className='mb-0 fs-14'>Boat Brand Headphones</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$810.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Nike Shoes</h5>
                                                <p className='mb-0 fs-14'>Nike Brand Sports Shoes</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$640.00</h4>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className='fw-normal mb-1 fs-17'>Milton Bottle</h5>
                                                <p className='mb-0 fs-14'>Milton Brand Water Bottle</p>
                                            </div>
                                            <h4 className='mb-0 fs-20'>$640.00</h4>
                                        </div>
                                        <hr />

                                        <div className='text-center'>
                                            <Button variant="primary">Loading <Icon spin path={mdiReload} className="btn-icon ms-1" /></Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xl={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Purchase Report</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>
                                        <Chart options={charts.purchaseReportChart.options} type="line" series={charts.purchaseReportChart.series} width="100%" height="295px" />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Total Purchase Product</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>
                                        <TableElement tableClass={topPurchaseProd.tableClass} thead={topPurchaseProd.thead} tbodydata={topPurchaseProd.tbody} />
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col lg={6}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Total Sales Product</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>
                                        <TableElement tableClass={topSalesProd.tableClass} thead={topSalesProd.thead} tbodydata={topSalesProd.tbody} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <Card.Title className='d-flex justify-content-between'>
                                            <span>Product Alert Quantity</span>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="link drop-link" id="dropdown-basic">
                                                    <Icon path={mdiDotsHorizontal} className='icon-size-24' />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item href="">Last 28 Days</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Month</Dropdown.Item>
                                                    <Dropdown.Item href="">Last Year</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Card.Title>

                                        <Table responsive className='table-sm table-nowrap mb-0'>
                                            <thead>
                                                <tr>
                                                    <th>Product Name</th>
                                                    <th>Categories</th>
                                                    <th>Price</th>
                                                    <th>Retail Qty</th>
                                                    <th>Alert Retail Qty</th>
                                                    <th>Consumable Qty</th>
                                                    <th>Alert Consumable Qty</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productData.slice(0, 25).map((data, i) =>
                                                    <tr key={i}>
                                                        <td>{data.product.description}</td>
                                                        <td>{getProductCategoryNameById(data.product.product_category_id)}</td>
                                                        <td>{data.product.maximum_retail_price}</td>
                                                        <td>{data.instore_retail_qty}</td>
                                                        <td>{data.alert_retail_quantity}</td>
                                                        <td>{data.instore_consumable_qty}</td>
                                                        <td>{data.alert_consumable_quantity}</td>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light btn-sm px-2" id="dropdown-basic">
                                                                    <Icon path={mdiDotsVertical} className='icon-size-15' />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
